<template>
  <div class="main-content-container container-fluid px-4">
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Overview</span>
        <h3 class="page-title">Register Details</h3>
      </div>
    </div>
    <d-card class="card-small mb-4">
      <!-- Card Header -->
      <d-card-header class="border-bottom">
        <h6 class="m-0">Register View</h6>
        <router-link :to="{ name: 'Register'}">
          <button
            class="btn btn-md btn-primary"
            style="margin-left: 900px;background-color:white;margin-top:-40px;color:black;"
          >Dashboard</button>
        </router-link>
      </d-card-header>
      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col>
              <d-form>
                <d-form-row>
                  <!-- Email -->
                  <d-col class="col-lg-12 col-md-12 col-sm-12 col-xs-12 row">
                    <d-col class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-horizontal">
                      <d-col class="form-group">
                        <label class="col-md-6 col-form-label">FirstName</label>
                        <div class="col-md-7">
                          <label
                            style="font-weight:600"
                          >{{Register.DataModel.Data.Register.FirstName}}</label>
                        </div>
                      </d-col>
                      <d-col class="form-group">
                        <label class="col-md-6 col-form-label">Mobile Number</label>
                        <div class="col-md-7">
                          <label
                            style="font-weight:600"
                          >{{Register.DataModel.Data.Register.ContactNumber}}</label>
                        </div>
                      </d-col>
                      <d-col class="form-group">
                        <label class="col-md-6 col-form-label">AccountHolder Name</label>
                        <div class="col-md-7">
                          <label
                            style="font-weight:600"
                          >{{Register.DataModel.Data.Register.AccountHolderName}}</label>
                        </div>
                      </d-col>
                      <d-col class="form-group">
                        <label class="col-md-6 col-form-label">Status</label>
                        <div class="col-md-7">
                          <label style="font-weight:600">{{"New"}}</label>
                        </div>
                      </d-col>

                      <!-- <d-col class="form-group">
                        <label class="col-md-5 col-form-label">LastName</label>
                        <div class="col-md-7">
                          <label
                            style="font-weight:600"
                          >{{Register.DataModel.Data.Register.LastName}}</label>
                        </div>
                      </d-col>-->
                    </d-col>
                    <!-- Password -->
                    <d-col class="col-lg-5 col-md-6 col-sm-12 col-xs-12 form-horizontal">
                      <d-col class="form-group">
                        <label class="col-md-5 col-form-label">LastName</label>
                        <div class="col-md-7">
                          <label
                            style="font-weight:600"
                          >{{Register.DataModel.Data.Register.LastName}}</label>
                        </div>
                      </d-col>

                      <d-col class="form-group">
                        <label class="col-md-5 col-form-label">Email ID</label>
                        <div class="col-md-7">
                          <label
                            style="font-weight:600"
                          >{{Register.DataModel.Data.Register.EmailId}}</label>
                        </div>
                      </d-col>
                      <d-col class="form-group">
                        <label class="col-md-5 col-form-label">Account No</label>
                        <div class="col-md-7">
                          <label
                            style="font-weight:600"
                          >{{Register.DataModel.Data.Register.BankAccountNumber}}</label>
                        </div>
                      </d-col>
                      <d-col class="form-group">
                        <label class="col-md-5 col-form-label">IFSC</label>
                        <div class="col-md-7">
                          <label style="font-weight:600">{{Register.DataModel.Data.Register.IFSC}}</label>
                        </div>
                      </d-col>
                    </d-col>
                  </d-col>
                </d-form-row>
                <br />

                <!-- <div class style="text-align:center">
                  <d-button
                    type="button"
                    id="submit"
                    class="btn-accent"
                    @click="SubmitRegister"
                    style="margin-right:10px"
                  >Submit</d-button>
                  <d-button
                    type="button"
                    id="submit"
                    class="btn-accent"
                    @click="ClearRegister"
                  >Cancel</d-button>
                </div>-->
              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
  </div>
</template>
<script src="https://checkout.razorpay.com/v1/checkout.js"></script>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";

export default {
  name: "Register",
  data() {
    return {
      Register: {
        PageType: "Master", // Master, Transaction, Dashboard, Tabb edDashboard
        PageLoad: true, // block/none
        DataModel: {
          Data: {
            Register: {
              Id: 0,
              FirstName: null,
              LastName: null,
              EmailId: null,
              ContactNumber: null,
              State: null,
              City: null,
              Country: null,
              AccountNo: null,
              AccountHolderName: null,
              BankName: null,
              TotalProfitAmount: null,
              Name: null,
              CheckoutDate: null,
              Status: {
                Name: null
              },
              CompanyId: null,
              CreatedBy: 1
            }
          },
          UIData: {}
        },
        PageState: "Default", // Default, Changed/Dirty, Submitted, PageLoading Dirty means some values are changed in the page
        TabInfo: {
          SelectedTabIndex: 0,
          NumberOfTabs: 0
        },
        SessionInfo: {
          SessionTimeout: false,
          AuthToken: "",
          SessionID: "",
          PageInfo: {
            ClientId: 0,
            userId: 0,
            ServiceRegisterID: null,
            WareHouseId: 0
          }
        },
        GridInfo: {},
        Events: {
          EventRaised: "Submitted", // Saved, Submitted, Cancelled, AutoCompletionTextChanged,
          PageToNavigateWhenSubmitted: "" // We can go back to dashboard or stay on the Same page or to a specific page
        },
        ValidationInfo: {},
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: ""
          }
        ],
        Masters: {
          RegisterList: []
        },
        Modal: {},
        CharRestrict: {}
      }
    };
  },
  mounted() {
    this.ListRegister();
    this.Register.SessionInfo.PageInfo.ServiceRegisterID = sessionStorage.getItem(
      "SelectedRegisterID"
    );
    this.GetByRegister();
  },
  methods: {
    Select() {
      console.log(this.Register.DataModel.Data.Register);
    },

    SubmitRegister() {
      let vm = this;
      if (
        Utilities.IsNotNullOrEmptyOrUndefined(
          vm.Register.DataModel.Data.Register.Name
        ) &&
        Utilities.IsNotNullOrEmptyOrUndefined(
          vm.Register.DataModel.Data.Register.FirstName
        ) &&
        Utilities.IsNotNullOrEmptyOrUndefined(
          vm.Register.DataModel.Data.Register.UnitPrice
        )
      ) {
        this.Register.DataModel.Data.CRUD = "Update";

        var dataString = JSON.stringify(this.Register.DataModel.Data);
        axios
          .post(
            "APIScript/PHP/APIService/Registration/Registration.php",
            dataString
          )
          .then(function(response) {
            if (response.data.ErrorInfo == null) {
              console.log(response.data);
              // Vue.$toast.success("Save Successfully");
            } else {
              if (
                !Utilities.IsNotNullOrEmptyOrUndefined(
                  vm.Register.DataModel.Data.Register.FirstName
                ) ||
                !Utilities.IsNotNullOrEmptyOrUndefined(
                  vm.Register.DataModel.Data.Register.LastName
                )
              ) {
                console.log(response.data.ErrorInfo);
                vm.$swal.fire(
                  "Information missing",
                  "Please provid FirstName, Last Name,  and Unit Price ",
                  "error"
                );
              } else {
                console.log(response.data.ErrorInfo);
                vm.$swal.fire(
                  "Oops...",
                  "Incorrect First Name or Last Name or  or Unit Price !",
                  "error"
                );
              }
            }
          })
          .catch(function(response) {
            console.log(response);
            vm.$swal.fire("Oops", "Something went worng", "error");
          });
      } else {
        vm.$swal.fire(
          "Information missing",
          "Please provid Name, FirstName and Unit Price ",
          "error"
        );
      }
    },
    GetByRegister() {
      var ServiceRegister = {
        Id: this.Register.SessionInfo.PageInfo.ServiceRegisterID
      };
      this.Register.DataModel.Data.Id = ServiceRegister.Id;
      let vm = this;
      // var DataStr = this.Register.DataModel.Data;
      var Token = sessionStorage.getItem("Token");
      this.Register.DataModel.Data.Token = Token;
      this.Register.DataModel.Data.CRUD = "GetById";
      var dataString = JSON.stringify(this.Register.DataModel.Data);
      axios
        .post(
          "APIScript/PHP/APIService/Registration/Registration.php",
          dataString
        )
        .then(function(response) {
          if (response.data.ErrorInfo == null) {
            // vm.Register.DataModel.Data = response.data.Result;
            vm.Register.DataModel.Data.Register = response.data.Result;
            //      vm.Register.DataModel.Data.Register.map(function(value,key){

            //     value.LastName = Utilities.TransactionCurrencyFormat(value.LastName);

            // });

            //  vm.Coupon.DataModel.Data.Coupon = response.data.Result;
            console.log(vm.Register.DataModel.Data);
          } else if (response.data.ErrorInfo == "Invalid Attempt") {
            this.$router.push({ name: "Login" });
          }
        })
        .catch(function(response) {
          return response;
        });
    },

    ListRegister() {
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.Register.DataModel.Data.Token = Token;
      this.Register.DataModel.Data.CRUD = "List";
      var dataString = JSON.stringify(this.Register.DataModel.Data);
      axios
        .post(
          "APIScript/PHP/APIService/Registration/Registration.php",
          dataString
        )
        .then(function(response) {
          if (response.data.ErrorInfo == null) {
            return response;
          } else if (response.data.ErrorInfo == "Invalid Attempt") {
            this.$router.push({ name: "Login" });
          }
        })
        .catch(function(response) {
          console.log(response.data.ErrorInfo);
        });
    },

    ClearRegister() {
      (this.Register.DataModel.Data.Register.LastName = null),
        (this.Register.DataModel.Data.Register.FirstName = null);
    }
  }
};
</script>
